module.exports = __webpack_public_path__ + "static/media/quebon-song-speech-sound.394e5d9a.mp3";